import { createFileRoute } from "@tanstack/react-router";

const ProjectTasksRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/projects/$id/tasks/")({
	component: ProjectTasksRoute,
});
